import React, { useState, useEffect } from "react";
import '../../styles/Dashboard.css'; // Optional, for styling
import Swal from 'sweetalert2';
import { formatCurrencyUSD } from "../../utils/format";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false); // Initially set loading to false
  const [error, setError] = useState(null);
  const [text_search, setTextSearch] = useState(''); // Initial empty string for search field
  const [clientIDText, setClientIDText] = useState(''); // Holds the client ID
  const [isVisible, setIsVisible] = useState(false);


  // Handle input change
  const handleChangeSearch = (event) => {
    setTextSearch(event.target.value);
  };

  // Handle form submit
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!text_search.trim()) {
      Swal.fire({
        title: "Searching...",
        text: "Please enter a valid Client ID or Contact ID",
        showConfirmButton: true,
        confirmButtonColor: '#A5CC2D', 
        willClose: () => {}, // optional callback
      });
      setIsVisible(false); // Show loading data section
      return;
    }
    setClientIDText(text_search); // Update clientIDText on submit
    //setLoading(true); // Set loading to true when starting the fetch request
    Swal.fire({
      title: "Searching...",
      text: `Searching Client ID / Contact ID: ${text_search}`,
      timer: 1500,
      showConfirmButton: false,
      willClose: () => {}, // optional callback
    });
    
  };

  //Fetch data when the clientIDText changes
  useEffect(() => {
    if (clientIDText === '') return; // Don't make the API call if the search text is empty
    
    const fetchData = async () => {
      
      try {
        setIsVisible(true); // Show loading data section
        const [validateRes] = await Promise.all([
          fetch(`https://eouwqhs4r5vcemm.m.pipedream.net/api/EPF/ValidateClient?search_value=${clientIDText}`,
            {
                method: "GET",
                headers: {
                "Authorization":`Bearer f48bf454f88ea1b9167651a392d934c6b67a9ae784b6a297b7e9e86020ead2e3`,
                "Content-Type": "application/json",
                }
            }
          )
        ]);

         if (!validateRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const validateData = await validateRes.json();
        setData(validateData);
        setError(null);

      } catch (err) {
        setError(err);
        Swal.fire({
          icon: "error",
          title: "We're unable to get the data.",
          text: "Kindly contact PDR Support for assistance.",
          confirmButtonColor: '#A5CC2D', 
        });
      } finally {
        setLoading(false);
      }

      setIsVisible(false); // Show loading data section
    };

    fetchData();
    
  }, [clientIDText]); // Trigger API call when clientIDText changes



  // // If loading, show a loading message or icon
  // if (loading) return <div className="loading-spinner">Loading...</div>;

  // // If there's an error, show an error message
  // if (error) return <div className="danger-badge">Error: {error.message}</div>;

  return (
    <div className="dashboard">
      <div className="flex-container">
        <div className="column search">
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                id="text-input-search"
                className="form-control"
                placeholder="Search Client ID"
                value={text_search}
                onChange={handleChangeSearch}
              />
              <button type="submit" className="btn btn-secondary" onClick={() => setIsVisible(!isVisible)}>
                Search
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Display fetched data */}
      <div className="flex-container">

        <div className="column">
          <label className="container-title">Contact ID (FORTH ID)</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count"  id="contact-id">{data.ContactID || '0'}</label>
        </div>
        
        <div className="column">
          <label className="container-title">Client ID (CFT ID)</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count" id="client-id">
            {data.ClientID || '0'}
          </label> {/* Fallback if data not loaded */}
        </div>

        <div className="column">
          <label className="container-title">External ID (DM ID)</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count" id="external-id">
            {data.ExternalID || '0'}
          </label>
        </div>

        <div className="column">
          <label className="container-title">Savings Account Balance</label>
          {isVisible && (<span className="spinner"></span>)}
          <label 
            className="container-count" 
            id="balance-id"  
            style={{
              color: data.Balance < 0? 'red' : 'green',
              }}
            >{formatCurrencyUSD(Number(data.Balance || '0.00').toFixed(2))}</label>
        </div>

      </div>

      <div className="flex-container">
        <div className="column">
          <label className="container-name" id="client-name">
          {isVisible && (<span className="spinner"></span>)}
            {data.ClientName || 'Client'}
             <span className="badge" id="client-status">
              {data.ClientStatus || 'INACTIVE'}
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
